<template>
  <div class="dfc">
    <a href="#" style="margin-left: auto; margin-right: auto;">
      <img class="logo" width="120" src="//prepclass.com.ng/img/logo.png">
    </a>
    <a class="right bold" style="font-weight: 600; text-decoration: underline;">{{ active_test && active_test.ability_subject && active_test.ability_subject.subject && active_test.ability_subject.subject.name }} Test</a>
    <div class="container">
      <div class="test--overlay" v-if="duplicate">
        <h1>You can't take this test because someone else is already taking it.</h1>
      </div>
      <div class="test--container" v-else>
        <div class="notification-alert alert alert-danger" role="alert" v-show="dup">
          <span>Someone just tried taking this test for you.</span>
          <span style="cursor: pointer; float: right;" @click="removeNotification(notification.id)"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0px" y="0px" viewBox="0 0 212.982 212.982" style="enable-background:new 0 0 212.982 212.982;" xml:space="preserve" width="9px" height="9px"><g id="Close"><path style="fill-rule:evenodd;clip-rule:evenodd;" d="M131.804,106.491l75.936-75.936c6.99-6.99,6.99-18.323,0-25.312   c-6.99-6.99-18.322-6.99-25.312,0l-75.937,75.937L30.554,5.242c-6.99-6.99-18.322-6.99-25.312,0c-6.989,6.99-6.989,18.323,0,25.312   l75.937,75.936L5.242,182.427c-6.989,6.99-6.989,18.323,0,25.312c6.99,6.99,18.322,6.99,25.312,0l75.937-75.937l75.937,75.937   c6.989,6.99,18.322,6.99,25.312,0c6.99-6.99,6.99-18.322,0-25.312L131.804,106.491z" fill="#721c24"/></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg></span>
        </div>
        <div class="top">
          <p class="time">Remaining Time {{ time_left }}</p>
          <a class="right" title="Quit Test" @click="quit">
            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0px" y="0px" viewBox="0 0 16 16" style="enable-background:new 0 0 16 16;" xml:space="preserve" width="512px" height="512px" class=""><g><g><path d="M8,0C3.582,0,0,3.582,0,8s3.582,8,8,8s8-3.582,8-8S12.418,0,8,0z M7,3c0-0.5,0.5-1,1-1s1,0.5,1,1v4   c0,0.5-0.5,1-1,1S7,7.5,7,7V3z M8,13c-2.762,0-5-2.238-5-5c0-2.051,1.234-3.812,3-4.584v2.348C5.387,6.313,5,7.111,5,8   c0,1.657,1.343,3,3,3s3-1.343,3-3c0-0.889-0.387-1.687-1-2.236V3.416C11.766,4.188,13,5.949,13,8C13,10.762,10.762,13,8,13z" data-original="#030104" class="active-path" data-old_color="#8cb5d4" fill="#fafafa"/></g></g></svg>
          </a>
        </div>
        <test-component v-for="(q, i) of active_test.questions" :key="i" :test="test" :question="i + 1"></test-component>
        <div class="col-12 makdd">
          <div class="submit" ref="submit" id="dslakfjdlsa">
            <a class="btn btn-success right submit-button" @click="submitAnswers">Submit Test</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import swal from 'sweetalert';
import Echo from 'laravel-echo';
import TestComponent from './TestComponent';

export default {
  props: ['test'],
  name: 'test-index',
  components: { TestComponent },
  beforeRouteEnter(to, from, next) {
    next(vm => vm.$store.getters.active_test.id || vm.$router.push({ name: 'test-status' }));
  },
  beforeDestroy() {
    this.$store.commit('RESET_TEST');
    if (this.active_test) {
      this.echo.leave(`test.${this.active_test.id}`);
    }
  },
  mounted() {
    this.echo = new Echo({
      broadcaster: 'pusher',
      key: PUSHER_APP_KEY,
      cluster: 'eu',
      encrypted: true,
      authEndpoint: `${BASE_API}/broadcasting/auth`,
      auth: {
        headers: {
          Authorization: `Bearer ${this.$auth.token()}`,
          Accept: 'application/json',
        },
      },
    });
    if (!this.$route.params.question) {}
    if (!this.active_test) {
      this.$router.push({ name: 'test-status' });
    }
    this.listen();
  },
  beforeRouteUpdate(to, from, next) {
    next();
  },
  data() {
    return {
      echo: {},
      dup: false,
      duplicate: false,
    };
  },
  computed: {
    active_test() {
      console.log(this.$store.getters.active_test);
      return this.$store.getters.active_test;
    },
    first_question() {
      return 1;
    },
    time_left() {
      const t = this.$store.getters.test_time_left;
      console.log('time left' + t);
      if (t === 0) {
        this.submit();
      }
      return `${this.pad(moment.duration(t, 'seconds').minutes())}:${this.pad(moment.duration(t, 'seconds').seconds())}`;
    },
    r() {
      return this.$route.params.question;
    },
    nextable() {
      return this.r && (this.r + 1) <= this.active_test.questions.length;
    },
    previousable() {
      return this.r && (this.r - 1) > 0;
    },
  },
  methods: {
    previous() {
      if (this.previousable) {
        if (this.$route.path.indexOf('dashboard') >= 0) {
          return this.$router.push({
            name: 'test-question-dash',
            params: { question: (this.r - 1) },
          });
        }
        return this.$router.push({ name: 'test-question', params: { question: (this.r - 1) } });
      }
      console.log(this.previousable);
      return null;
    },
    next() {
      if (this.nextable) {
        if (this.$route.path.indexOf('dashboard') >= 0) {
          return this.$router.push({
            name: 'test-question-dash',
            params: { question: (this.r + 1) },
          });
        }
        return this.$router.push({ name: 'test-question', params: { question: (this.r + 1) } });
      }
      console.log(this.nextable);
      return null;
    },
    quit() {},
    submit() {
      return this.$store.dispatch('submitAnswers')
        .then((response) => {
          this.$nextTick(() => this.$store.commit('RESET_TEST'));
          if (this.$route.query.dashboard) {
            this.$router.push({ name: 'test-status-dash', query: { test: this.test } });
          } else {
            this.$router.push({ name: 'test-status', query: { test: this.test } });
          }
        })
        .catch((error) => {
          this.$nextTick(() => this.$store.commit('RESET_TEST'));
          if (this.$route.query.dashboard) {
            this.$router.push({ name: 'test-status-dash' });
          } else {
            this.$router.push({ name: 'test-status' });
          }
        });
    },
    submitAnswers() {
      return swal({
        title: 'Are you sure',
        text: 'Are you sure you want to submit this test. Please note that by clicking submit will immediately end your entire test and show your overall test result. If you do not wish to submit the test, click cancel and then click "Next question" to see the next question',
        icon: 'warning',
        buttons: ['Cancel', 'Submit ➜'],
      }).then((value) => {
        if (value) {
          const res = window.confirm('Are you really sure? This really can\'t be undone.');
          if (res) {
            this.submit();
          }
        }
      });
    },
    pad(n) {
      return n < 10 ? `0${n}` : n;
    },
    listen() {
      if (this.active_test) {
        this.echo.join(`test.${this.active_test.id}`)
          .here((users) => {
            const t = users.filter(u => u.id === this.$auth.user().id).length;
            if (t > 1) {
              this.duplicate = true;
            }
          })
          .joining((user) => {
            if (user.id === this.$auth.user().id) {
              this.dup = true;
            }
          })
          .leaving((user) => {
            if (user.id === this.$auth.user().id) {
              this.dup = false;
            }
          });
      }
    },
  },
};
</script>

<style lang="scss">
  .makdd {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 0;
  }
  .dfc {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    padding-top: 25px;
  }
  .test--container {
    padding: 10px;
    min-heigth: 100%;

    .right {float: right;}
    .top { width: 100%; height: 20px; padding:10px; svg {width: 20px; height: 20px;} p.time {float: right; margin-left: 20px; font-size: 18px; margin-bottom: 0; color: #639440; font-weight: 900; letter-spacing: 2px;}}

    .actions {
      width: 100%;
      max-width: 280px;
      height: 64px;
      margin-top: 25px;
      margin-bottom: 20px;
      padding: 0 25px;
      color: #639440;
      display: flex;
      flex-direction: row;
      justify-content: space-evenly;
      align-items: center;
      padding: 5px;
      border-radius: 7px;

      a {
        font-size: 14px;
        color: white;
        display: flex;
        flex-direction: row;
        align-items: center;
        color: #639440;
        cursor: pointer;
        &:hover {text-decoration: underline;}
        svg { height: 14px; width: 14px; margin: 0 15px;}
      }
      div.divider {height: 100%; width: 1px; background-color: rgba(0, 0, 0, 0.25);}
    }
    .submit {
      display: flex;
      flex-direction: flex-start;
      padding: 0 25px;
      .submit-button {
        width: 130px;
        height: 35px;
        line-height: 35px;
        padding: 0 10px;
        text-align: center;
        border-radius: 4px;
        color: #ffffff;
        font-size: 12px;
        vertical-align: middle;
        box-shadow: 0 2px 2px 0 rgba(40, 167, 69, 0.14), 0 3px 1px -2px rgba(40, 167, 69, 0.12), 0 1px 5px 0 rgba(40, 167, 69, 0.2);
        &:focus {
          outline: 0 !important;
          box-shadow: none !important;
          &:active {box-shadow: none !important;}
        }
      }
    }
  }
  @media only screen and (max-width: 600px) {
  .hold {margin-bottom: 35px; margin-top: 20px;}
  .title {font-size: 16px;}
  .ase {padding: 10px; margin-bottom: 25px; h5 {font-size: 14px;}}
  table.table-borderless {font-size: 10px !important;}
  .test--container {
    .actions {margin-top: 5px;}
    .submit {
      margin-top: 55px;
      position: absolute;
      .submit-button:not(.ignore) {
        position: fixed;
        bottom: 0;
        width: 100%;
        height: 54px;
        line-height: 54px;
        float: left;
        left: 0;
        border-radius: 0;
        text-transform: uppercase;
        margin: 0;
      }
    }
  }
  .makdd {
    flex-direction: column-reverse;
    justify-content: center;
    margin-top: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/Test/Test.vue